import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

const SUPPORTED_CARD_TYPES = [
  CARD_TYPE_MAP.std,
  CARD_TYPE_MAP.dstd,
  CARD_TYPE_MAP.thankyou,
  CARD_TYPE_MAP.holiday,
];

export type PhotoPreviewSupportedCardType = typeof SUPPORTED_CARD_TYPES[number];

export const isPhotoPreviewSupported = (
  cardType?: string
): cardType is PhotoPreviewSupportedCardType =>
  SUPPORTED_CARD_TYPES.includes(cardType as PhotoPreviewSupportedCardType);

export const ZOLA_PLP_PHOTO_PREVIEW = 'ZOLA_PLP_PHOTO_PREVIEW';
export const PLP_PREVIEW_LIVE_PHOTO = 'PLP_PREVIEW_LIVE_PHOTO';
export const PLP_SWAP_LIVE_PHOTO = 'PLP_SWAP_LIVE_PHOTO';
export const PLP_ADD_LIVE_PHOTO = 'PLP_ADD_LIVE_PHOTO';
